
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { BestTimeToVisitOption } from '../hooks/useFilterOptions';
import { CalendarDays } from 'lucide-react';

interface BestTimeFilterProps {
  value: string | null;
  options: BestTimeToVisitOption[];
  onChange: (value: string) => void;
}

export const BestTimeFilter = ({ value, options, onChange }: BestTimeFilterProps) => {
  return (
    <div className="space-y-4">
      <Label className="text-sm font-medium mb-2 block">Best Time to Visit</Label>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select season" />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.key} value={option.key}>
              <div className="flex items-center gap-2">
                <CalendarDays className="w-4 h-4 text-gray-500" />
                <span>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
